

































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ContactLensFKU from '@/models/item/fku/contact-lens'
import ContactLensFKURepository from '@/models/item/fku/repository'
import ContactLensRootRepository from '@/models/item/root/repository'
import { UsualPowerService } from '@/services/api/usual-power/usual-power'
import AppId from '@/util/appid'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import ContactLensItemDetailStore from './store'
import ContactLensItemDetailStoreBuilder from './store-builder'

@Component
export default class ContactLensColorVariation extends Vue {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  initialDisplayedFkuId: string

  store: ContactLensItemDetailStore | null = null

  async created() {
    try {
      const brandName = BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
      const appId = AppId.getByBrandName(brandName)
      const storeBuilder = ContactLensItemDetailStoreBuilder.getInstance(
        new ContactLensRootRepository(appId),
        new ContactLensFKURepository(appId),
        new UsualPowerService()
      )
      this.store = await storeBuilder.build(
        this.id,
        BehaviorConfig.createFromBrand(brandName),
        this.initialDisplayedFkuId
      )
    } catch (error) {
      console.error(error)
    }
  }

  get fkus(): ContactLensFKU[] {
    return this.store ? this.store.fkus : []
  }

  isSelectedFku(fkuId: string): boolean {
    if (!this.store || !this.store.selectedFku) {
      return false
    }

    return this.store.selectedFku.id === fkuId
  }

  onClick(fku: ContactLensFKU): void {
    if (this.store && !this.isSelectedFku(fku.id)) {
      this.store.selectFku(fku)
    }
  }
}
